type Callback<K extends string | number | symbol, V> = (entry: [K, V]) => void;

/**
 * Iterates over each key-value pair in the given object and executes the provided callback function.
 *
 * @template Type - The type of the object.
 * @template K - The type of the keys in the object.
 * @template V - The type of the values in the object.
 * @param {Type} obj - The object to iterate over.
 * @param {Callback<keyof Type, Type[keyof Type]>} callback - The function to execute for each key-value pair.
 */
export function objectForEach<
  Type extends Record<string | number | symbol, unknown>,
>(obj: Type, callback: Callback<keyof Type, Type[keyof Type]>): void {
  Object.entries(obj).forEach(([key, value]) => {
    callback([key as keyof Type, value as Type[keyof Type]]);
  });
}
